<template>
  <div class="container salespersonDataShow" v-loading="loading" element-loading-text="拼命加载中">
    <el-tabs type="border-card" class="card-tab">
      <el-tab-pane label="筛选">
        <el-form :model="param" :inline="true" label-width="70px" class="formInline" size="mini" :rules="rules">
          <div class="slide-wrap" ref="slideWrap1">
            <el-form-item label="项目编号">
              <el-input v-model="param.projectNo" placeholder="请输入准确的项目编号..." :maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="项目名称">
              <el-input v-model="param.projectName" placeholder="请输入项目名称..."></el-input>
            </el-form-item>
            <el-form-item label="品类">
              <el-input v-model="param.brand" placeholder="请输入品类..."></el-input>
            </el-form-item>
            <el-form-item label="身份证" prop="idCard">
              <el-input v-model="param.idCard" placeholder="请输入身份证..." :maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="星级">
              <el-input v-model.number="param.rank" placeholder="请输入星级..." :maxlength="5"></el-input>
            </el-form-item>
            <el-form-item label="所在地区">
              <el-select v-model="param.province" filterable placeholder="请选择省份..." @change="searchCity">
                <el-option label="不限" :value="null"></el-option>
                <el-option :label="item.adName" :value="item.adName" v-for="item in provinceList"
                           :key="item.id"></el-option>
              </el-select>
              <el-select v-model="param.city" filterable placeholder="请选择城市...">
                <el-option label="不限" :value="null"></el-option>
                <el-option :label="item.adName" :value="item.adName" v-for="item in cityList"
                           :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <hr style="margin-bottom: 9px;">
          <div class="slide-btns clearfix">
            <el-form-item>
              <el-button type="text" class="reset-btn" @click="resetForm()">清空</el-button>
              <el-button class="search-btn" @click="submitForm()">筛选</el-button>
            </el-form-item>
            <div class="floatr">
              <el-form-item>
                <el-button type="text" class="slide-btn" @click="toggleSlide('slideWrap1', $event)">展开筛选项</el-button>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <el-row class="common-box" style="margin-top: 20px;">
      <div class="common-box-btn clearfix">
        <h2 class="floatl">筛选结果</h2>
        <el-button type="primary" size="mini" round @click="getExcel">
          导出表格 <i class="el-icon-download"></i>
        </el-button>
      </div>
      <div class="common-box-body">
        <el-table ref="multipleTable"
                  :data="tableData"
                  size="small"
                  v-loading="listLoading"
                  element-loading-text="拼命加载中"
                  border
                  tooltip-effect="dark"
                  style="width: 100%"
                  header-row-class-name="table-header">
          <!--<el-table-column type="selection" width="50" align="center" fixed></el-table-column>-->
          <el-table-column type="index" label="编号" min-width="45" align="center"></el-table-column>
          <el-table-column prop="agency" label="Agency" min-width="70" align="center"></el-table-column>
          <el-table-column prop="province" label="省份" width="80" align="center"></el-table-column>
          <el-table-column prop="city" label="城市" width="80" align="center"></el-table-column>
          <el-table-column prop="idcard" label="身份证号" min-width="135" align="center"
                           :formatter="formatIdCard"></el-table-column>
          <el-table-column prop="eSalesmanId" label="促销员ID" min-width="90" align="center"></el-table-column>
          <el-table-column prop="salesmanName" label="促销员姓名" min-width="90" align="center"
                           :formatter="formatName"></el-table-column>
          <el-table-column prop="storeCode" label="门店SFA Code" min-width="110" align="center"></el-table-column>
          <el-table-column prop="banner" label="Banner" min-width="100" align="center"></el-table-column>
          <el-table-column prop="workExperence" label="工作经验" min-width="140" align="center"></el-table-column>
          <el-table-column prop="projectNo" label="项目编号" min-width="150" align="center"></el-table-column>
          <el-table-column prop="projectName" label="项目名称" min-width="300" align="center"></el-table-column>
          <el-table-column prop="category" label="Category" min-width="100" align="center"></el-table-column>
          <el-table-column prop="brand" label="品类" min-width="100" align="center"></el-table-column>
          <el-table-column prop="trainGrade" label="培训成绩" min-width="75" align="center"></el-table-column>
          <el-table-column prop="planWorkDays" label="计划工作天数" min-width="70" align="center"></el-table-column>
          <el-table-column prop="virtualWorkDays" label="实际工作天数" min-width="70" align="center"></el-table-column>
          <el-table-column prop="sheduleCompletionRate" label="档期内执行场次完成率" min-width="90" align="center"
                           :formatter="formatPercent"></el-table-column>
          <el-table-column prop="activeDutyRate" label="活动在岗率" min-width="90" align="center"
                           :formatter="formatPercent"></el-table-column>
          <el-table-column prop="activeDutyGrade" label="活动在岗成绩" min-width="95" align="center"></el-table-column>
          <el-table-column prop="targetSales" label="目标销量" min-width="80" align="center"></el-table-column>
          <el-table-column prop="virtualSales" label="实际销量" min-width="80" align="center"></el-table-column>
          <el-table-column prop="virtualPosSales" label="实际销量（POS）" min-width="80" align="center"></el-table-column>
          <el-table-column prop="salesRate" label="销量达成率" min-width="90" align="center"
                           :formatter="formatPercent"></el-table-column>
          <el-table-column prop="rank" label="星级" min-width="60" align="center"></el-table-column>
        </el-table>

        <el-pagination class="pagination table-pagination"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="param.pageNo"
                       :page-sizes="[10, 20, 30, 40]"
                       :page-size="param.pageSize"
                       layout="slot, total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </el-row>

  </div>
</template>

<script>
  import utils from '../../common/js/util.js'
  import rules from '../../common/js/formRules'

  export default {
    name: "salesperson-data-show",
    data() {
      return {
        //筛选项参数
        param: {
          projectNo: '', //项目编号
          projectName: '', //项目名称
          brand: '',//品类，不是品类标签
          province: '', //省级id
          city: '', //区级id
          idCard: '', //身份证号
          rank: '',//星级
          pageNo: 1,//数据页码总数信息
          pageSize: 10,//当前页展示的信息条数
        },
        starLevelList: [],//获取到的星级列表
        signIdLst: [],//存储tag组件返回的选择的品类
        provinceList: [],//存储省-列表数据
        cityList: [],//存储获取到城市列表
        tableData: [],//展示的表格数据
        total: null,//总数
        uploadDialog: false,//是否展示上传对话框
        listLoading: false,//列表的loading
        loading: false,//全局loading
        rules: {idCard: rules.idcard,}//表单校验规则
      }
    },
    mounted() {
      //获取省市列表数据
      this.searchProvince();
      //获取数据
      this.getData();
    },
    methods: {
      //展开收起
      toggleSlide(slideWrap, event) {
        if (this.$refs[slideWrap].offsetHeight == 42) {
          this.$refs[slideWrap].style.height = "auto";
          event.target.innerHTML = "收起筛选项";
        } else {
          this.$refs[slideWrap].style.height = "42px";
          event.target.innerHTML = "展开筛选项";
        }
      },
      //搜索省市
      searchProvince(id) {
        this.$http({
          method: "POST",
          url: "/rest/salesman/getRegion",
          params: {
            deep: 1,
            regionId: id
          }
        }).then(res => {
          this.provinceList = res.data;
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询省市数据失败，请稍后重试')
        })
      },

      //清空筛选项
      resetForm() {
        this.param.projectNo = null;
        this.param.projectName = null;
        this.param.brand = null;
        this.param.province = '';
        this.param.city = '';
        this.param.idCard = null;
        this.param.rank = '';
      },
      //提交表单（筛选功能）
      submitForm() {
        //是否要加上是否是市辖区的逻辑？如果是则city为市辖区
        this.getData();
      },
      //获取筛选数据
      getData() {
        this.listLoading = true;
        //获取table数据
        this.$http({
          method: "get",
          url: "/rest/BaoJieCr/searchBaoJieCr",
          params: this.param
        }).then(res => {
          this.tableData = res.data;
          this.listLoading = false;
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
          this.listLoading = false;
        })
        //获取页码数据
        this.$http({
          method: "get",
          url: "/rest/BaoJieCr/searchBaoJieCrSize",
          params: this.param
        }).then(res => {
          this.total = res.data;
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      //获取城市列表
      searchCity() {
        let id = null;
        this.param.cityId = null;
        this.provinceList.map(item => {
          if (this.param.province == item.adName) {
            id = item.id;
          }
        })
        if (id != null) {
          this.$http({
            method: "POST",
            url: "/rest/salesman/getRegion",
            params: {
              deep: 2,
              regionId: id
            }
          }).then(res => {
            this.cityList = res.data;
          }).catch(err => {
            utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
          });
        }
      },
      //对于非超级管理员，需要把数据加密
      //身份证加密
      formatIdCard(row, column, cellValue) {
        if (cellValue.length == 15) {
          return utils.plusXing(cellValue, 7, 4)
        } else if (cellValue.length == 18) {
          return utils.plusXing(cellValue, 6, 4)
        } else {
          console.log('身份证位数不对', cellValue)
        }
      },
      //姓名加密
      formatName(row, column, cellValue) {
        if (cellValue) {
          return utils.plusXing(cellValue, 1, 1)
        }
      },
      //数字转百分比
      formatPercent(row, column, cellValue) {
        let x = 0
        if (cellValue != 0) {
          x = parseFloat((cellValue * 100).toFixed(2)) + '%'
        }
        return x
      },
      //每页的显示条目改变时
      handleSizeChange(val) {
        this.param.pageSize = val;
        this.getData();
      },
      //手动选择页码时
      handleCurrentChange(val) {
        this.param.pageNo = val;
        this.getData();
      },
      //导出表格
      getExcel() {
        this.loading = true;//进入全局loading
        this.$http({
          method: "GET",
          url: "/rest/BaoJieCr/downLoadBaoJieCr",
          params: this.param
        }).then(res => {
          this.loading = false;
          location.href = utils.returnUrlHead() + res.data.message;
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '下载失败，请稍后重试')
          this.loading = false;
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/personnelCenter/salespersonDataShow.vue